import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from './AppProviders';
import { AppRouter } from './core/react-router';
import { AuthExpirationListener } from './features/auth/components/AuthExpirationListener';
import { addFonts } from './core/fonts';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';

addFonts();

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AppProviders>
            <AppRouter />
          </AppProviders>
          <AuthExpirationListener />
        </BrowserRouter>
      </PersistGate>
    </Provider>
    
  );
}

export default App;
